export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11653.e99f96ee.jpg";